import React, {Dispatch, SetStateAction} from "react";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField/TextField";
import {Controller} from "react-hook-form";
import Select from "react-select";
import {ErrorMessage} from "@hookform/error-message";
import Divider from "@material-ui/core/Divider";
import moment from "moment";
import {Checkbox, FormControlLabel, ListItem, Radio, RadioGroup} from "@material-ui/core";
import {apollo_useStyles} from "../atom/Apollo_styles";
import makeAnimated from "react-select/animated";

export const ApolloBasicLabel: React.FC<{
  label: string,
  value: string,
  className?: string,
  style?: Object
}> = (props) => {

  const className = props.className ? props.className : "";
  const style = props.style ? props.style : {};
  return (
    <React.Fragment key={props.label}>
      <Grid item xs={6}
            className={className}
            style={style}>
        <Typography>{props.label}</Typography>
      </Grid>
      <Grid item xs={6}
            className={className}
            style={style}>
        <Typography>{convertBrTag(props.value)}</Typography>
      </Grid>
    </React.Fragment>
  )
}

export const ApolloBasicTwoLineLabel: React.FC<{
  label: string,
  value: string,
  labelClassName?: string,
  labelStyle?: Object
  valueClassName?: string,
  valueStyle?: Object
}> = (props) => {

  const labelClassName = props.labelClassName ? props.labelClassName : "";
  const labelStyle = props.labelStyle ? props.labelStyle : {};
  const valueClassName = props.valueClassName ? props.valueClassName : "";
  const valueStyle = props.valueStyle ? props.valueStyle : {};
  return (
    <React.Fragment key={props.label}>
      <Grid item xs={12}
            className={labelClassName}
            style={labelStyle}>
        <Typography>{props.label}</Typography>
      </Grid>
      <Grid item xs={12}
            className={valueClassName}
            style={valueStyle}>
        <Typography>{convertBrTag(props.value)}</Typography>
      </Grid>
    </React.Fragment>
  )
}

const convertBrTag = (value: string) => {
  return (
    value.split('\n').map((str, idx) => (
      <React.Fragment key={idx}>{str}<br/></React.Fragment>
    ))
  )
}

export const ApolloBasicTextField: React.FC<{
  id: string,
  label: string,
  value: any,
  className?: string,
  style?: Object,
  variant?: any,
  type?: string,
  multiline?: boolean,
  minRows?: any,
  maxRows?: any,
  disabled?: boolean,
  placeholder?: string,
  onChange?: any,
  required?: boolean,
  inputRef?: any,
  inputProps?: any,
  error?: any,
  unNegative?: boolean,
  onBlur?: any,
  setState?: any,

}> = (props) => {
  return (
    <React.Fragment>
      <TextField
        id={props.id}
        name={props.id}
        className={props.className ? props.className : ""}
        style={props.style ? props.style : {}}
        disabled={props.disabled}
        required={props.required}
        type={props.type ? props.type : ""}
        multiline={props.multiline}
        minRows={props.minRows}
        maxRows={props.maxRows}
        label={props.label}
        fullWidth
        inputRef={props.inputRef ? props.inputRef : {}}
        inputProps={props.inputProps ? props.inputProps : {}}
        helperText={props.error ? props.error?.message : ""}
        error={props.error}
        placeholder={props.placeholder ? props.placeholder : ""}
        variant={props.variant ? props.variant : "standard"}
        value={props.value}
        key={props.id}
        onBlur={(e) => {
          if (props.onBlur) {
            props.onBlur(e.currentTarget.value);
          }
        }}
        onChange={((e) => {
          if (props.setState) {
            let value = e.currentTarget.value;
            // 数値入力欄の場合は半角数のみ有効
            if (props.type === "number" && props.unNegative) {
              props.setState(Number(value) > -1 ? value : null);
            } else {
              props.setState(value);
            }
          }
          if (props.onChange) {
            props.onChange(e);
          }
        })}
      />
    </React.Fragment>
  )
}

export const ApolloBasicSelect: React.FC<{
  id: string,
  label: string,
  value: any,
  defaultValue?: any,
  className?: string,
  style?: Object,
  disabled?: boolean,
  readOnly?: boolean,
  isMulti?: boolean,
  options: Array<{ value: any; label: string }>,
  closeMenuOnSelect?: boolean,
  menuPlacement?: "bottom" | "top" | "auto",
  onChange?: any,
  control: any,
  rules?: object,
  errors: any,
  setState: any,
  setValue?: any,
  placeholder?: any,
  attention?: any,
  selectStyle?: any,
  isClearable?: boolean,
}> = (props) => {

  const classes = apollo_useStyles();
  const animatedComponents = makeAnimated();

  const readOnly = props.readOnly ? props.readOnly : false;
  const localValue = props.isMulti ?
    props.value.length === 0 ?
      null : props.options.filter(c => props.value.includes(c.value))
    : props.value === 0 ? null : props.options.find(c => c.value === props.value)

  const selectStyle = props.selectStyle ? props.selectStyle : {}

  if (props.setValue) {
    props.setValue(props.id, localValue)
  }

  return (
    <React.Fragment>
      {props.label !== "" &&
      <Typography variant="subtitle1" gutterBottom component="div">
        {props.label}
      </Typography>
      }
      {props.attention &&
        props.attention
      }
      <Controller
        style={props.style ? props.style : {}}
        id={props.id}
        className={props.className ? props.className : ""}
        name={props.id}
        defaultValue={localValue}
        render={
          (
            {onChange, value, name}
          ) => (
            <Select
              menuPortalTarget={document.body}
              styles={
                {
                  menuPortal: base => ({...base, zIndex: 9999}),
                  multiValueRemove: (base) => ({...base, display: readOnly ? 'none' : "block"}),
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    ...selectStyle
                  }),
                }
              }
              value={localValue}
              options={props.options}
              onChange={(val: any) => {
                if (props.isMulti) {
                  onChange(val)
                  if (props.onChange) {
                    props.onChange(val)
                  }
                  props.setState(val)
                } else if (props.isClearable) {
                  if(val == null) {
                    onChange(null)
                    if (props.onChange) {
                      props.onChange(null)
                    }
                    props.setState(null)
                  } else {
                    onChange(val.value)
                    if (props.onChange) {
                      props.onChange(val.value)
                    }
                    props.setState(val.value)
                  }
                } else {
                  onChange(val.value)

                  if (props.onChange) {
                    props.onChange(val.value)
                  }
                  props.setState(val.value)
                }
              }
              }
              closeMenuOnSelect={props.closeMenuOnSelect !== false}
              isDisabled={props.disabled}
              isClearable={((!readOnly && props.isMulti) || props.isClearable)}
              isSearchable={!readOnly}
              openMenuOnClick={!readOnly}
              menuIsOpen={readOnly ? false : undefined}
              isMulti={props.isMulti}
              control={props.control}
              components={animatedComponents}
              menuPlacement={props.menuPlacement}
              placeholder={props.placeholder ?? "Select..."}
            />
          )}
        /*                menuPlacement={props.menuPlacement ? props.menuPlacement : "auto"}*/
        rules={props.rules ? props.rules : {}}
        control={props.control}
        key={props.id}
      />
      <ErrorMessage
        errors={props.errors ? props.errors : {}}
        name={props.id}
        as={<Typography variant="caption" className={classes.errorMessage}/>}
      />
    </React.Fragment>
  )
}

export const ApolloBasicCheck: React.FC<{
  id: string,
  label: string,
  checked: any,
  className?: string,
  style?: Object,
  disabled?: boolean,
  onChange?: any,
  rules?: object,
  errors?: any,
  color?: string,
  setState: any,
  labelPlacement?: any,
}> = (props) => {
  const classes = apollo_useStyles();
  const color = props.color === "primary" ? "primary" : "secondary";
  return (
    <React.Fragment>
      <FormControlLabel
        control={
          <Checkbox
            id={props.id}
            name={props.id}
            onChange={((e) => {
              props.setState(e.currentTarget.checked)
              if (props.onChange) {
                props.onChange(e)
              }
            })}
            color={color}
            checked={props.checked}
          />
        }
        disabled={props.disabled}
        label={props.label}
        labelPlacement={props.labelPlacement ? props.labelPlacement : "start"}
        key={props.checked}
      />
      <ErrorMessage
        errors={props.errors ? props.errors : {}}
        name={props.id}
        as={<Typography variant="caption" className={classes.errorMessage}/>}
      />
    </React.Fragment>
  )
}

export const ApolloBasicRadio: React.FC<{
  id: string,
  label: string,
  value: any,
  options: Array<{ value: any; label: string }>,
  className?: string,
  style?: Object,
  disabled?: boolean,
  onChange?: any,
  control: any,
  rules?: object,
  errors: any,
  setState: any,
}> = (props) => {

  const classes = apollo_useStyles();

  return (
    <React.Fragment>
      <Typography variant="subtitle1" gutterBottom component="div">
        {props.label}
      </Typography>
      <Controller
        name={props.id}
        style={props.style ? props.style : {}}
        render={(radioProps) =>
          <RadioGroup
            onChange={((e) => {
              props.setState(e.currentTarget.value)
              if (props.onChange) {
                props.onChange(e)
              }
            })}
            className={props.className}
            value={props.value}

          >
            <ListItem>
              {props.options.map(elem => <FormControlLabel value={elem.value} control={<Radio/>}
                                                           label={elem.label}
                                                           disabled={props.disabled}/>)}
            </ListItem>
          </RadioGroup>
        }

        rules={props.rules ? props.rules : {}}
        key={props.id}
        control={props.control}
      />
      <ErrorMessage
        errors={props.errors ? props.errors : {}}
        name={props.id}
        as={<Typography variant="caption" className={classes.errorMessage}/>}
      />
    </React.Fragment>
  )
}

export const ApolloBasicDistributionDate: React.FC<{
  startDate: {
    id: string,
    value: any,
    disabled?: boolean,
    inputRef?: any,
    inputProps?: any,
    errors?: any,
    isAfterNow?: boolean,
    setState: any,
    dateOnly?: any,
  },
  endDate: {
    id: string,
    value: any,
    inputType: number,
    setInputType: Dispatch<SetStateAction<number>>,
    disabled?: boolean,
    inputRef?: any,
    inputProps?: any,
    errors?: any,
    setState: any,
    dateOnly?: any,
    inputTypeDisabled?: {
      radio1: boolean,
      radio2: boolean,
    },
  },
}> = (props) => {

  const classes = apollo_useStyles();
  const handleChangeDateType = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.endDate.setInputType(Number((event.target as HTMLInputElement).value));
  };
  return (
    <React.Fragment>
      <Grid container spacing={1}>
        <Divider/>
        <Grid container item xs={12} spacing={0}>
          <Typography variant="subtitle1" gutterBottom
                      component="div">{`掲載期間${props.startDate.isAfterNow ? "　※掲載期間以降は開始日時を変更できません" : ""}`}</Typography>
        </Grid>
        <Grid container item xs={1} spacing={0}>
        </Grid>
        <Grid container item xs={1} spacing={0} alignItems="center">
          <Typography>開始</Typography>
        </Grid>
        <Grid container item xs={10} spacing={0}>
          <Grid container spacing={1}>
            <Grid container item xs={12} spacing={0} className={classes.postPeriodStartDate}
                  style={props.startDate.dateOnly ? {minWidth: 500, marginLeft: 15} : {minWidth: 500, marginLeft: 0}}>
              <TextField
                required
                id={props.startDate.id}
                name={props.startDate.id}
                type={props.startDate.dateOnly ? "date" : "datetime-local"}
                disabled={props.startDate.disabled}
                defaultValue={moment(props.startDate.value).format(props.startDate.dateOnly ? "YYYY-MM-DD" : "YYYY-MM-DDTHH:mm")}
                inputRef={props.startDate.inputRef ? props.startDate.inputRef : {}}
                InputProps={props.startDate.inputProps ? {inputProps: props.startDate.inputProps} : {}}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
                onBlur={((e) => {
                  props.startDate.setState(e.currentTarget.value)
                })}
                helperText={props.startDate.errors && props.startDate.errors.message}
                error={props.startDate.errors}
                key={props.startDate.value}
              /> {props.startDate.dateOnly ? "※時刻は00時00分固定で設定いたします" : ""}
            </Grid>
          </Grid>
        </Grid>
        <Grid container item xs={12} spacing={0} className={classes.postPeriodSeparate}>
        </Grid>
        <Grid container item xs={1} spacing={0}>
        </Grid>
        <Grid container item xs={1} spacing={0} alignItems="center">
          <Typography>終了</Typography>
        </Grid>
        <Grid container item xs={10} spacing={0}>
          <RadioGroup name="endDateType"
                      value={props.endDate.inputType}
                      className={classes.radioGroup}
                      onChange={handleChangeDateType}>
            <Grid container spacing={1}>
              <Grid container item xs={12} spacing={0} alignItems="center">
                <FormControlLabel value={1} control={<Radio/>} label="継続的に配信"
                                  disabled={props.endDate.inputTypeDisabled !== undefined && props.endDate.inputTypeDisabled?.radio1}/>
              </Grid>
              <Grid container item xs={1} spacing={0} alignItems="center">
                <FormControlLabel value={2} control={<Radio/>} label=""
                                  disabled={props.endDate.inputTypeDisabled !== undefined && props.endDate.inputTypeDisabled?.radio2}/>
              </Grid>
              <Grid container item xs={10} spacing={0} alignItems="center">
                <TextField
                  required
                  id={props.endDate.id}
                  name={props.endDate.id}
                  type={props.endDate.dateOnly ? "date" : "datetime-local"}
                  defaultValue={moment(props.endDate.value).format(props.endDate.dateOnly ? "YYYY-MM-DD" : "YYYY-MM-DDTHH:mm")}
                  inputRef={props.endDate.inputRef ? props.endDate.inputRef : {}}
                  InputProps={props.endDate.inputProps ? {inputProps: props.endDate.inputProps} : {}}
                  onBlur={((e) => {
                    props.endDate.setState(e.currentTarget.value)
                  })}
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  helperText={props.endDate.errors && props.endDate.errors.message}
                  error={props.endDate.errors}
                  key={props.endDate.value}
                /> {props.endDate.dateOnly ? "※時刻は23時59分固定で設定いたします" : ""}
              </Grid>
            </Grid>
          </RadioGroup>
        </Grid>
      </Grid>
    </React.Fragment>
  )
}
export const ApolloBasicPeriod: React.FC<{
  startDate: {
    id: string,
    label: string,
    value: any,
    disabled?: boolean,
    inputRef?: any,
    inputProps?: any,
    errors?: any,
    isAfterNow?: boolean,
    setState: any,
    dateOnly?: any,
    className?: string,
    message:string,
    isSysAdmin?:boolean
  },
  endDate: {
    id: string,
    label: string,
    value: any,
    disabled?: boolean,
    inputRef?: any,
    inputProps?: any,
    errors?: any,
    isAfterNow?: boolean,
    setState: any,
    dateOnly?: any,
    className?: string,
    message?:string
  },
  isAuthorization : boolean
}> = (props) => {

  return (
    <React.Fragment>
          <Grid item xs={2} md={6}>
            <Grid container spacing={3}>
            {!props.isAuthorization && (
              <Grid item xs={12}  style={{padding:6}}>※開始、終了は、2025年10月1日以降を入力してください。 </Grid>)}
               <Grid item xs={6} style={{}}>
             <TextField
                 label={props.startDate.label}
                 id={props.startDate.id}
                 name={props.startDate.id}
                 type="datetime-local"
                 defaultValue={moment(props.startDate.value).format(props.startDate.dateOnly ? "YYYY-MM-DD" : "YYYY-MM-DDTHH:mm")}
                 inputRef={props.startDate.inputRef ? props.startDate.inputRef : {}}
                 InputProps={props.startDate.inputProps ? {inputProps: props.startDate.inputProps} : {}}
                 className={props.startDate.className ? props.startDate.className : ""}
                 InputLabelProps={{
                   shrink: true,　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　
                 }}
                 onBlur={((e) => {
                   props.startDate.setState(e.currentTarget.value)
                 })}
                 helperText={props.startDate.errors && props.startDate.errors.message}
                 error={props.startDate.errors}
                 key={props.startDate.value}
                 style={{width: "100%"}}
               />
             <span style={{fontSize: "12px", color: "blue"}}>{props.startDate.message}</span>
           </Grid>
           <Grid item xs={6} style={{}}>
               <TextField
                 label={props.endDate.label}
                 id={props.endDate.id}
                 name={props.endDate.id}
                 style={{width: "100%"}}
                 type="datetime-local"
                 defaultValue={moment(props.endDate.value).format(props.endDate.dateOnly ? "YYYY-MM-DD" : "YYYY-MM-DDTHH:mm")}
                 inputRef={props.endDate.inputRef ? props.endDate.inputRef : {}}
                 InputProps={props.endDate.inputProps ? {inputProps: props.endDate.inputProps} : {}}
                 className={props.endDate.className ? props.endDate.className : ""}
                 InputLabelProps={{
                   shrink: true,
                 }}
                 onBlur={((e) => {
                   props.endDate.setState(e.currentTarget.value)
                 })}
                 helperText={props.endDate.errors && props.endDate.errors.message}
                 error={props.endDate.errors}
                 key={props.endDate.value}
               />
             <span style={{fontSize: "12px", color: "blue"}}>{props.endDate.message}</span>
             </Grid>
            </Grid>
          </Grid>
    </React.Fragment>
  )
}
export const ApolloCustomTextField: React.FC<{
  id: string,
  label: string,
  value: any,
  className?: string,
  style?: Object,
  variant?: any,
  type?: string,
  multiline?: boolean,
  minRows?: any,
  maxRows?: any,
  disabled?: boolean,
  placeholder?: string,
  onChange?: any,
  required?: boolean,
  inputRef?: any,
  inputProps?: any,
  error?: any,
  unNegative?: boolean,
  onBlur?: any,
  setState?: any,
  helperText?: string, // 新規追加
}> = (props) => {
  return (
    <React.Fragment>
      <TextField
        id={props.id}
        name={props.id}
        className={props.className ? props.className : ""}
        style={props.style ? props.style : {}}
        disabled={props.disabled}
        required={props.required}
        type={props.type ? props.type : ""}
        multiline={props.multiline}
        minRows={props.minRows}
        maxRows={props.maxRows}
        label={props.label}
        fullWidth
        inputRef={props.inputRef ? props.inputRef : {}}
        inputProps={props.inputProps ? props.inputProps : {}}
        helperText={props.helperText || (props.error ? props.error?.message : "")}
        FormHelperTextProps={{
          style: {
            color: "red", // 赤文字にする
          },
        }}
        error={props.error}
        placeholder={props.placeholder ? props.placeholder : ""}
        variant={props.variant ? props.variant : "standard"}
        value={props.value}
        key={props.id}
        onBlur={(e) => {
          if (props.onBlur) {
            props.onBlur(e.currentTarget.value);
          }
        }}
        onChange={((e) => {
          if (props.setState) {
            let value = e.currentTarget.value;
            // 数値入力欄の場合は半角数のみ有効
            if (props.type === "number" && props.unNegative) {
              props.setState(Number(value) > -1 ? value : null);
            } else {
              props.setState(value);
            }
          }
          if (props.onChange) {
            props.onChange(e);
          }
        })}
      />
    </React.Fragment>
  );
};